export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9923.81787b0e.jpg";